<template>
  <div class="img_box" @click="goVkAuth">
    <img class="login_other_img" src="../../../assets/img/h5_login_icon09.png" />
  </div>
</template>
<script>
var _self;
import { myMixin } from "@/tools/mixins.js";
export default {
  name: "LoginVK",
  mixins: [myMixin],
  data() {
    return {
      appId: "6973099",
    };
  },
  mounted() {
    _self = this;
    //access_token=4a4c364adda9c50d9e0c5dedb5ec697e8325b47deee556fd078db54aacb1cf543f7c2627b6b5cb9b07132&expires_in=86400&user_id=543541596
    let type = this.getParamsHash('type');
    let user_id = this.getParamsHash('user_id');
    let access_token = this.getParamsHash('access_token');
    // console.log(user_id);
    // console.log(user_id);
    // console.log(access_token);
    if(type==='VK'&&user_id&&access_token){
      this.confirmLogin(12,{
        "uid":user_id,
        "accessToken":access_token
      });
    }
  },
  methods: {
    goVkAuth() {
      let platform = 'bcnewpay'+this.getSuffix()
      this.gosdkAuth(1,`VKAuth.html?platform=${platform}`)
    }
    //跳转中转页授权
    // goAuth(){
    //   window.location.href="https://callb.xuoj.com/loginAuth/VKAuth.html?suiji="+Date.parse(new Date());
    // },

  },
};
</script>
<style scoped>
.img_box {
  margin: 0 0.15rem;
}
.login_other_img {
  width: 0.76rem;
  height: 0.76rem;
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/Login/LoginSdk/LoginSdkVK.vue